import { cn } from "@/libs/cn";
import { Space } from "antd";
import { GenderTag } from "./GenderTag";

export function RoomCard(
	props: Room & { actions?: React.ReactNode; showRetreat?: boolean },
) {
	const { name, count, maxiCount, meditationEvent, actions, showRetreat } =
		props;

	const isFull = count === maxiCount;

	return (
		<article
			title={name}
			className={cn(
				"w-full border border-gray-300 rounded-xl font-poppins flex flex-col self-stretch text-center overflow-hidden aspect-4/3 transition-all hover:shadow-lg duration-300 animate-fade-in ",
				"group-[.ant-checkbox-wrapper-checked]:bg-f80/10 group-[.ant-checkbox-wrapper-checked]:border-f80", //for checkbox
				"group-[&>.ant-radio-wrapper-checked]:bg-f80/10! group-[&>.ant-radio-wrapper-checked]:border-f80!", //for radio
			)}
		>
			<h3
				className={cn(
					"font-semibold transition-colors line-clamp-2 p-4 py-2 border-b border-gray-300 duration-300 ",
					"group-[.ant-checkbox-wrapper-checked]:text-f80 group-[.ant-checkbox-wrapper-checked]:border-f80/50", //for checkbox
					"group-[&>.ant-radio-wrapper-checked]:text-f80 group-[&>.ant-radio-wrapper-checked]:border-f80/50 ", //for radio
				)}
			>
				{name}
			</h3>
			<Space
				direction="vertical"
				className={cn(
					"w-full p-4 items-center justify-center flex-1 bg-gray-50 duration-300 transition-all",
					"group-[.ant-checkbox-wrapper-checked]:bg-transparent", //for checkbox
					"group-[&>.ant-radio-wrapper-checked]:bg-transparent ", //for radio
				)}
			>
				{showRetreat ? (
					<p
						className={cn(
							"text-xs transition-colors ",
							"group-[.ant-checkbox-wrapper-checked]:text-f80", //for checkbox
							"group-[&>.ant-radio-wrapper-checked]:text-f80 ", //for radio
						)}
					>
						Maximum : {maxiCount}
					</p>
				) : (
					<p className="text-sm text-gray-400">
						<span
							className={cn("text-success", {
								"text-danger": isFull,
							})}
						>
							{count} / {maxiCount}
						</span>{" "}
						{isFull ? " (Full)" : ""}
					</p>
				)}
				{showRetreat && meditationEvent && (
					<p className="text-xs group-[.ant-checkbox-wrapper-checked]:text-f80 transition-colors ">
						{meditationEvent?.level.name}
						{meditationEvent?.title
							? ` - ${meditationEvent.title}`
							: "-"}
					</p>
				)}
				<GenderTag {...props} />
			</Space>
			{actions}
		</article>
	);
}
